export default {
  SYS_ADMIN: 'Admin',
  BILLING_USER: 'Billing User',
  PHARMACIST: 'Pharmacist',
  PHARM_TECH: 'Pharmacy Technician',
  CCC: 'Customer Care Coordinator',
  PHARM_PROD_TECH: 'Pharmacy Production Technician',
  SHIPPING_USER: 'Shipping User',
  INVENTORY_ADMIN: 'Inventory Admin',
  INVENTORY_MANAGER: 'Inventory Manager',
  INVENTORY_VIEWER: 'Inventory Viewer',
  INVOICE_ADMIN: 'Invoice Admin',
};
